document.addEventListener('DOMContentLoaded', () => {
    const tabsBlocks = document.querySelectorAll('.mm-generic-blocks-tabs');
    const stickyBlocks = document.querySelectorAll('.wp-block-mm-generic-blocks-sticky-container');
    const modalBlocks = document.querySelectorAll('body:not(.wp-admin):not(.block-editor-iframe__body) .wp-block-mm-generic-blocks-modal-container');

    tabsBlocks && tabsBlocks.forEach((tab) => {
        const tabTriggers = tab.querySelectorAll('[data-bs-toggle="tab"]');

        tabTriggers && tabTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                const targetId = trigger.getAttribute('data-bs-target');
                const targetTab = targetId ? tab.querySelector(targetId) : null;

                if (!targetTab) {
                    console.warn(`Target tab ${targetId} not found.`);
                    return;
                }

                const activeTabs = tab.querySelectorAll('.nav-link.active, .tab-pane.show.active');
                activeTabs.forEach((activeElement) => {
                    activeElement.classList.remove('active', 'show');
                });

                trigger.classList.add('active');
                targetTab.classList.add('active', 'show');
            });
        });
    });

    stickyBlocks && stickyBlocks.forEach((sticky) => {
        const closeBtn = sticky.querySelector('.close');

        closeBtn && closeBtn.addEventListener('click', () => {
            sticky.classList.remove('visible');
            sticky.remove();
        });

        window.addEventListener('scroll', () => {
            const viewportHeight = window.innerHeight;
            const scrollThreshold = parseFloat(sticky.dataset.scroll || '0');
            const elementOffsetTop = sticky.offsetTop;
            const scrollPosition = window.scrollY;
            const elementViewportPercentage =
                ((scrollPosition + viewportHeight - elementOffsetTop) / viewportHeight) * 100;

            if (elementViewportPercentage > scrollThreshold) {
                sticky.classList.add('visible');
            }
        });
    });

    modalBlocks && modalBlocks.forEach((modal) => {
        const closeButton = modal.querySelector("button.btn-close");
        let modalClosed = false;

        const showModal = () => {
            if (modalClosed) return;
            modal.classList.add("show");
            modal.style.display = "block";
            document.body.classList.add("modal-open");
        };

        const hideModal = () => {
            modal.classList.remove("show");
            modal.style.display = "none";
            document.body.classList.remove("modal-open");
            modalClosed = true;

            window.removeEventListener('scroll', scrollHandler);
        };

        const scrollHandler = () => {
            const viewportHeight = window.innerHeight;
            const scrollThreshold = parseFloat(modal.dataset.value || '0');
            const elementOffsetTop = modal.offsetTop;
            const scrollPosition = window.scrollY;
            const elementViewportPercentage =
                ((scrollPosition + viewportHeight - elementOffsetTop) / viewportHeight) * 100;

            if (elementViewportPercentage > scrollThreshold) {
                showModal();
            }
        };

        closeButton && closeButton.addEventListener("click", hideModal);
        modal.addEventListener("click", function (e) {
            if (e.target === modalElement) hideModal();
        });

        if (modal.dataset.trigerType === 'scroll') {
            window.addEventListener('scroll', scrollHandler);
        }

        if (modal.dataset.trigerType === 'timeout') {
            const timeoutInSeconds = modal.dataset.value ? parseInt(modal.dataset.value, 10) : 0;

            if (!isNaN(timeoutInSeconds)) {
                const timeoutInMilliseconds = timeoutInSeconds * 1000;

                setTimeout(() => {
                    showModal();
                }, timeoutInMilliseconds);
            }
        }
    });
});